// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal{border:1px solid #d3d3d3;background-color:#fff;top:100px;left:0;right:0;margin-left:auto;margin-right:auto}.form-control{display:block;width:100%;height:30px;margin-bottom:10px}.footer{padding:10px;text-align:right}.footer>button{margin-left:10px}.body,.headers{padding:10px}.headers{border-bottom:1px solid #d3d3d3}.condition{display:flex;justify-content:space-between}.condition .el-input,.condition .el-select{width:90%}", ""]);
// Exports
module.exports = exports;
